<template>
  <v-card min-width="35%" rounded="lg">
    <v-card-title class="primary"> Вход </v-card-title>
    <v-divider />
    <v-form @submit.prevent="Authenticate">
      <v-card-text>
        <v-text-field
          prepend-inner-icon="mdi-account-question-outline"
          filled
          required
          label="Логин"
          v-model="username"
          :rules="[(v) => !!v || `Обязательное поле`]"
        />
        <v-text-field
          prepend-inner-icon="mdi-key"
          filled
          required
          label="Пароль"
          type="password"
          v-model="password"
          :rules="[(v) => !!v || `Обязательное поле`]"
        />
        <p class="text-uppercase text-center red--text" v-if="invalid">
          {{ text }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="primary"
          type="submit"
          light
          block
          :disabled="username == `` || password == ``"
          >Войти <v-icon>mdi-login</v-icon></v-btn
        >
      </v-card-actions>
    </v-form>
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="100"
        width="10"
        color="primary"
      />
    </v-overlay>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    username: "",
    password: "",
    invalid: false,
    text: "",
    isLoading: true,
  }),
  methods: {
    ...mapActions(["tryAuth", "tryLocalAuth"]),
    async Authenticate() {
      this.isLoading = true;
      try {
        await this.tryAuth({
          username: this.username,
          password: this.password,
        });
      } catch (e) {
        if (e.message == "Failed to fetch") {
          this.text = "Отсутсвует соединение с сервером лицензий";
        } else {
          this.text = e.message;
        }
        this.invalid = true;
      } finally {
        this.isLoading = false;
      }
    },
    async LocalAuth() {
      this.isLoading = true;
      try {
        await this.tryLocalAuth();
      } catch (e) {
        if (e.message == "Failed to fetch") {
          this.text = "Отсутсвует соединение с сервером лицензий";
        } else {
          this.text = e.message;
        }
        this.invalid = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.LocalAuth();
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.animated {
  animation: infinite linear 15s moveGrad !important;
  -webkit-animation: infinite linear 15s moveGrad !important;
  background: linear-gradient(-45deg, #81c784, #43a047, #c8e6c9);
  background-size: 400% 400%;
}

@keyframes moveGrad {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>